export const userConstants = {
    SET_USERS: "SET_USERS",
    UPDATE_USERS: "UPDATE_USERS",
    SET_USER: "SET_USER",
    SET_LOGS: "SET_LOGS",
};